import React, {FC} from 'react';
import styled from 'styled-components';

/*
 * Props.
 */

interface IntegrationFrameCardAvatarProps {
  integrationIconsUrl: string;
}

/*
 * Style.
 */

const StyledAvatarDiv = styled.div`
  grid-area: avatar;
  align-self: center;
  width: 30px;
  height: 30px;

  overflow: hidden;
  border-radius: 15px 15px;
  background-color: ${(p) => p.theme.greys.white};
`;

/*
 * Component.
 */

export const IntegrationFrameCardAvatar: FC<IntegrationFrameCardAvatarProps> = ({integrationIconsUrl}) => (
  <StyledAvatarDiv>
    <img alt="integration-card" src={`${integrationIconsUrl}card.svg`} />
  </StyledAvatarDiv>
);
